import { Observable, Subscription } from 'rxjs';

export function DoOnce(observable: Observable<any>, callback: Function) {
  const subscription: Subscription = observable.subscribe(event => {
    subscription.unsubscribe();
    callback(event);
  });
}
